import React from "react";
import { ArrowUpRight, MessageCircle } from "lucide-react";
import { Container, AxorButton, Reveal, Overline } from "@/components/primitives";
import { PrismHero, FloatingShard } from "@/components/Prism";
import { waLink } from "@/config";

export const CTASection = ({
  overline = "Get Started",
  title = "Ready To Shape Your Success?",
  description = "Your next opportunity starts with the right direction.",
  showJobs = true,
}) => (
  <section className="relative overflow-hidden py-24 md:py-32" data-testid="cta-section">
    <div className="absolute inset-0 bg-gradient-to-b from-axor-hero via-axor-deep to-axor-hero" />
    <div className="light-rays absolute inset-0" />
    <Container className="relative">
      <div className="relative grid items-center gap-12 overflow-hidden rounded-[32px] border border-white/[0.08] bg-white/[0.02] px-8 py-16 backdrop-blur-xl md:grid-cols-[1.5fr_1fr] md:px-16 md:py-20">
        <FloatingShard className="right-10 top-8 h-10 w-10" shape="diamond" delay={0.2} />
        <div>
          <Reveal>
            <Overline>{overline}</Overline>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 max-w-xl text-4xl font-semibold leading-[1.08] tracking-tight text-axor-white sm:text-5xl">
              {title}
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-5 max-w-md text-lg text-axor-text">{description}</p>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="mt-9 flex flex-wrap gap-4">
              {showJobs && (
                <AxorButton to="/jobs" icon={ArrowUpRight} data-testid="cta-explore-jobs">
                  Explore Jobs
                </AxorButton>
              )}
              <AxorButton
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                variant="secondary"
                icon={MessageCircle}
                data-testid="cta-talk-axor"
              >
                Talk To Axor
              </AxorButton>
            </div>
          </Reveal>
        </div>
        <div className="relative hidden md:block">
          <PrismHero className="mx-auto w-40" />
        </div>
      </div>
    </Container>
  </section>
);
